<template>
  <div class="flex h-screen font-roboto">
    <Sidebar />

    <div class="flex-1 flex flex-col overflow-hidden">
      <EnvironmentStrip />
      <Header />

      <div
        :class="[
          'flex-1 flex flex-col',
          $route.meta.fullHeight ? 'overflow-hidden' : 'overflow-y-auto'
        ]"
        style="z-index: 0"
      >
        <div
          :class="[
            'container-dashboard',
            isCompactShell ? 'container-dashboard--compact' : '',
            $route.meta.fullHeight ? 'min-h-0 overflow-hidden flex flex-col !pt-0 !pb-[10px]' : ''
          ]"
        >
          <slot />
        </div>
        <Footer v-if="!$route.meta.hideFooter" />
      </div>
    </div>

    <ChangelogPanel />
  </div>
</template>

<script>
import { computed } from 'vue'
import Sidebar from '../Sidebar.vue'
import Header from '../Header.vue'
import Footer from '../Footer.vue'
import ChangelogPanel from '../Changelog/ChangelogPanel.vue'
import EnvironmentStrip from '../EnvironmentStrip.vue'
import { useFeatureFlags } from '@/hooks/useFeatureFlags'
import { useShellIsMobile } from '@/hooks/useShellIsMobile'

export default {
  components: {
    Sidebar,
    Header,
    Footer,
    ChangelogPanel,
    EnvironmentStrip
  },
  setup() {
    // Sem a flag, `useShellIsMobile` é o `innerWidth < 800` legado e o padding NÃO pode mudar:
    // a classe compacta (0.75rem nas laterais, spec §4.2) só existe com a flag do celular.
    const { flags } = useFeatureFlags()
    const shellIsMobile = useShellIsMobile()
    const isCompactShell = computed(() => flags.enabledDashboardMobile && shellIsMobile.value)
    return { isCompactShell }
  }
}
</script>

<style scoped>
.container-dashboard {
  flex: 1;
  padding: 1rem 2rem;
  background-color: white;
}
.container-dashboard--compact {
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}
</style>
